import React, { useState } from "react";
import image from "../../assets/images/IllustrationContainer.png";
import logoimage from "../../assets/images/Logo.png";
import LoginHook from "./LoginHook";
import { baseURLProd } from "../../api";
import { toast,ToastContainer } from 'react-toastify';
const Login = () => {
  const {
    handleLogin,
    showPassword,
    handleClickShowPassword,
    showPassword2,
    handleClickShowPassword2,
    username,
    setUsername,
    password,
    setPassword,
  } = LoginHook();

  const [showDiv,setShowDiv] =useState(false);
  const [newPassword,setNewPassword] =useState("");
  const [confirmPassword,setConfirmPassword] =useState("");

  const handleForget=()=>{
    setShowDiv(true)
  }
  const handleForgetPassword = async (e) => {
        e.preventDefault();
    
        const formData = new FormData();
        formData.append("email", username);
        formData.append("password", newPassword);
        if (newPassword !== confirmPassword){
          alert('Passwords do not match')
        }
        else{
          try {
            const loginResponse = await fetch(`${baseURLProd}forget-password`, {
              method: "POST",
              body: formData,
            });
      
            const loginData = await loginResponse.json();
      
           
           
              if (loginData.status === true) {
                toast.success(loginData.message);
                setShowDiv(false)
              } else {
                alert("Login failed: " + loginData.message);
              }
          } catch (error) {
            console.error("Error during login process:", error);
            alert("An error occurred. Please try again later.");
          }
        }
      }
  return (
    <div className=" logindiv">
      <ToastContainer/>
      <div className="row">
        <div className="col-md-6 col-lg-6 col-sm-12">
          <img src={image} className="loginImg"></img>
        </div>
        {showDiv ?
        <div className="col-md-6 col-lg-6 col-sm-12">
          <div style={{ marginTop: "20px", width: "75%", marginLeft: "43px" }}>
            <div>
              <img src={logoimage} className="loginImg2" />
            </div>
            <div className="my-4">
              <label htmlFor="exampleFormControlInput1" className="form-label">
                Email address <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your Registered Email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="mt-4">
              <label htmlFor="exampleFormControlInput1" className="form-label">
               New Password <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter your Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  // style={{ flex: 1 }}
                />
                <span
                  onClick={handleClickShowPassword}
                  style={{ cursor: "pointer", marginLeft: "8px" }}
                >
                  {showPassword ? (
                    <i className="fa-regular fa-eye"></i>
                  ) : (
                    <i className="fa-regular fa-eye-slash"></i>
                  )}
                </span>
              </div>
            </div>
            <div className="mt-4">
              <label htmlFor="exampleFormControlInput1" className="form-label">
               Confirm Password <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type={showPassword2 ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter your Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  // style={{ flex: 1 }}
                />
                <span
                  onClick={handleClickShowPassword2}
                  style={{ cursor: "pointer", marginLeft: "8px" }}
                >
                  {showPassword2 ? (
                    <i className="fa-regular fa-eye"></i>
                  ) : (
                    <i className="fa-regular fa-eye-slash"></i>
                  )}
                </span>
              </div>
            </div>
            <div className="my-4">
              <button
                className="btn btn-secondary loginBtn"
                onClick={handleForgetPassword}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        :
        <div className="col-md-6 col-lg-6 col-sm-12">
          <div style={{ marginTop: "20px", width: "75%", marginLeft: "43px" }}>
            <div>
              <img src={logoimage} className="loginImg2" />
            </div>
            <div className="my-4">
              <label htmlFor="exampleFormControlInput1" className="form-label">
                Email address <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your Registered Email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="mt-4">
              <label htmlFor="exampleFormControlInput1" className="form-label">
                Password <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter your Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  // style={{ flex: 1 }}
                />
                <span
                  onClick={handleClickShowPassword}
                  style={{ cursor: "pointer", marginLeft: "8px" }}
                >
                  {showPassword ? (
                    <i className="fa-regular fa-eye"></i>
                  ) : (
                    <i className="fa-regular fa-eye-slash"></i>
                  )}
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-end mb-4 me-4" style={{cursor:"pointer"}} onClick={handleForget}>
              {/* <input type="checkbox" style={{ width: "20px" }}></input>
              <p className="ms-3 mt-3">Remember Me</p> */}
              <div >
                                <p><b>Forget Password ?</b></p>
                            </div>
            </div>
            <div>
              <button
                className="btn btn-secondary loginBtn"
                onClick={handleLogin}
              >
                Login
              </button>
            </div>
          </div>
        </div>
        }

      </div>
  
    </div>
  );
};

export default Login;
